var map = {
	"./NewMain.vue": 84028,
	"./NewSidebar.vue": 24629,
	"./NewSidebarItem.vue": 68452,
	"./NewToolbar.vue": 48013,
	"./SidebarFilter.vue": 7657,
	"./SidebarItem.vue": 18081,
	"./SvgIcon.vue": 64689
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44085;